import type { ApiLiquidityHubSnapshot, GetLiquidityHubHistoryResponse } from '..';

export const getApiLiquidityHubSnapshotArray = (
  payload?: GetLiquidityHubHistoryResponse | ApiLiquidityHubSnapshot[],
) => {
  if (!payload) {
    return [];
  }

  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload.result)) {
    return payload.result;
  }

  if (Array.isArray(payload.result?.data)) {
    return payload.result.data;
  }

  if (Array.isArray(payload.data)) {
    return payload.data;
  }

  return [];
};
